module.exports = __webpack_public_path__ + "static/02-a9b7280175761dd28ef70695b050d924.jpg";